<template>
  <div class="exchangeDetail">
    <div class="integralBreadcrumb">
      <div @click="jumpToMy">我的</div>
      <div class="el-icon-arrow-right"></div>
      <div @click="jumpTointegralExchange">积分兑换</div>
      <div class="el-icon-arrow-right"></div>
      <div>商品详情</div>
    </div>
    <div class="goodDetail">
      <div class="goodText" v-if="info">
        <img :src="info.thumbnailUrl?info.thumbnailUrl:'static/img/占位图.png'" alt="暂无图片"/>
        <div class="goodInfo">
          <h2>{{info.commodityName}}</h2>
          <p class="goodDescribe">{{info.commodityDescribe}}</p>
          <p class="goodScore">所需积分：<span style="color: #333333;">{{info.needIntegral}} x{{num}}</span></p>
          <p class="goodScore">商品库存：<span style="color: #333333;">{{info.integralCommodityInventory || 0}}</span></p>
          <div class="goodNum">
            <p>兑换数量：</p>
            <el-input-number style="width: 170px;" v-model="num" @change="handleChange" :min="1" :max="info.integralCommodityInventory" label="描述文字"></el-input-number>
          </div>
          <div @click="goChange" class="goChange" v-if="info.integralCommodityInventory">立即兑换</div>
          <div class="stopChange" v-else>库存不足</div>
        </div>
      </div>
      <!-- <img v-if="info" class="infoUrl" :src="info.infoUrl"> -->
      <div v-if="info" class="ql-editor" v-html="decodeURIComponent(info.content).replace(/%2F/g, '/')"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      info: null,
      num: 1,
      availableIntegral: null,
      addressList: null
    }
  },
  methods: {
    jumpToMy () {
      this.$router.push({ name: 'basicInfo' })
    },
    jumpTointegralExchange () {
      this.$router.push({
        name: 'integralExchange'
      })
    },
    goChange () {
      if (this.addressList.length === 0) {
        this.$message.warning('您还没有收获地址，请添加收货地址后再次尝试兑换商品')
      } else if (this.availableIntegral >= (this.info.needIntegral * this.num)) {
        this.$router.push({
          name: 'integralOrderCreate',
          query: {
            id: this.$route.query.id,
            num: this.num
          }
        })
      } else {
        this.$message.warning('您的积分不足，请减少商品数量或重新选择商品')
      }
    },
    handleChange (value) {
    },
    getGoodDetail () {
      this.$request.get(`/front/train/forum/integralExchangeCommodity/info/${this.$route.query.id}`)
        .then(data => {
          // console.log(data)
          this.info = data
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    },
    getIntegral () {
      this.$request.get(`/front/train/forum/integralOrder/myUserPoint`)
        .then((data) => {
          console.log(data, 'getIntegral')
          // if (data.code === 0) {
          this.availableIntegral = data.userPoint
          // } else {
          // this.$message.error(data.result.msg)
          // }
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    },
    getAddressList () {
      this.$request.postParam(`/front/consumer/user/address/selectUserAddressList`, {
        // params: {
        page: 1,
        limit: 10
        // companyId: (this.$store.state.user.defaultCompanyId + '') || ''
        // }
      })
        .then(data => {
          this.addressList = data.data || []
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    }
  },
  created () {
    this.getGoodDetail()
    this.getIntegral()
    this.getAddressList()
  }
}
</script>

<style scoped>
.exchangeDetail{
  width: 1190px;
  margin: 0 auto;
}
.integralBreadcrumb{
  display: flex;
  height: 20px;
  line-height: 20px;
  margin: 20px 0;
}
.integralBreadcrumb div:nth-of-type(1){
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(1):hover{
  font-weight: bold;
  color: #1D65A8;
}
.integralBreadcrumb div:nth-of-type(2){
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(3){
  font-weight: normal;
  font-size: 14px;
  color: #666666;
  user-select: none;
  cursor: pointer;
}
.integralBreadcrumb div:nth-of-type(3):hover{
  font-weight: bold;
  color: #1D65A8;
}
.integralBreadcrumb div:nth-of-type(4){
  font-weight: normal;
  width: 26px;
  text-align: center;
  font-size: 16px;
  color: #666666;
  line-height: 20px;
  user-select: none;
}
.integralBreadcrumb div:nth-of-type(5){
  font-weight: normal;
  font-size: 14px;
  color: #1D65A8;
  user-select: none;
}
.goodDetail{
  width: 1190px;
  padding-top: 30px;
  padding-left: 30px;
  padding-bottom: 34px;
  background: #ffffff;
}
.goodText{
  height: 382px;
  display: flex;
  margin-bottom: 40px;
  position: relative;
}
.goodText img{
  display: block;
  width: 382px;
  height: 382px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  margin-right: 20px;
}
.goodInfo h2{
  line-height: 50px;
  font-size: 24px;
  color: #333333;
  word-break: break-all;
}
.goodDescribe{
  width: 758px;
  line-height: 21px;
  font-size: 14px;
  color: #666666;
  padding-top: 12.5px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 33px;
}
.goodScore{
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  color: #666666;
  margin-bottom: 33px;
}
.goodNum{
  display: flex;
  height: 36px;
  line-height: 36px;
  align-items: center;
}
.goChange{
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  left: 402px;
  background: #1D65A8;
  user-select: none;
  cursor: pointer;
}
.stopChange{
  width: 150px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #ffffff;
  font-size: 16px;
  position: absolute;
  bottom: 0;
  left: 402px;
  background: #d7d7d7;
  user-select: none;
  cursor: pointer;
  pointer-events: none;
}
.infoUrl{
  display: block;
  box-sizing: border-box;
  width: 1130px;
  border: 1px solid #eeeeee;
}
.ql-editor >>> img { width: 100%; };
</style>
